import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import { FullSizeColumn } from '../../FlexBox';
import FormSelect from '../../Form/FormSelect';
import FormTextField from '../../Form/FormTextField';
import { activityOutcomesAtom } from '../../../Atoms';

const ManualActivityContent = function ManualActivityContent() {
  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const activityOutcomes = useAtomValue(activityOutcomesAtom);
  const activityOutcome = watch('activityOutcome');

  const manualOutcomes =
    activityOutcomes.MANUAL?.map(({ id, name, extensionData }) => {
      return {
        value: id,
        label: name,
        hasDynamicProgress: extensionData?.hasDynamicProgress,
      };
    }) || [];

  return (
    <FullSizeColumn gap="16px" padding="8px">
      <FormSelect
        required
        name="activityOutcome"
        options={manualOutcomes}
        error={errors?.activityOutcome}
      />
      {manualOutcomes.find(({ value }) => value === activityOutcome)
        ?.hasDynamicProgress && (
        <FormTextField
          required
          name="campaignAdvancement"
          type="number"
          icon={<PercentRoundedIcon />}
          error={errors?.campaignAdvancement}
        />
      )}
      <FormTextField name="notes" multiline error={errors?.notes} required />
    </FullSizeColumn>
  );
};

export default ManualActivityContent;
